import { useField } from "formik";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface TextareaFieldProps {
  name: string;
  label: string;
  rows?: number;
  placeholder?: string;
}

/** Formik-bound shadcn Textarea, matching FormField's error-rendering style. */
export function TextareaField({ name, label, rows = 3, placeholder }: TextareaFieldProps) {
  const [field, meta] = useField(name);
  const hasError = meta.touched && !!meta.error;
  return (
    <div className="grid gap-2">
      <Label htmlFor={name}>{label}</Label>
      <Textarea id={name} rows={rows} placeholder={placeholder} aria-invalid={hasError} {...field} />
      {hasError && <p className="text-destructive text-sm">{meta.error}</p>}
    </div>
  );
}
